import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export const usageTracker = createTracker({
  events,
  properties: {
    screen: 'case study editor',
    pageType: 'case study'
  },
  lastKnownEventProperties: ['screen', 'subscreen']
});